import { CDN_ROOT_IMAGES_PATH } from '@/constant/common';
import { SPECS_EXTS, SPECS_PATH_IDENTIFIERS } from '@/constant/dynamic';
import { getGlobalArgs } from '@/root/global';
import { getFileExtension } from '@/utils/navigation';

export const makeStaticImageUrlToConfigsServer = (imageName: string) =>
  `${getGlobalArgs('NEXT_PUBLIC_IMAGES_PROXY_URL')}${CDN_ROOT_IMAGES_PATH}/${imageName}`;

export const isPathToSpec = (path: string) => {
  const allowedExt = Object.values(SPECS_EXTS);

  return (
    Object.values(SPECS_PATH_IDENTIFIERS).some(ident => path.includes(`/${ident}/`)) &&
    allowedExt.includes(getFileExtension(path))
  );
};
